import { useState, useRef, useEffect } from 'react';

export default function useThankYouMessage(timeout = 2000) {
  const [message, setMessageState] = useState('');
  const timeoutRef = useRef(null);

  const clearExistingTimeout = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  };

  const showMessage = (text = 'thank_you_message') => {
    setMessageState(text);
    clearExistingTimeout();
    timeoutRef.current = setTimeout(hideMessage, timeout);
  };

  const hideMessage = () => {
    clearExistingTimeout();
    setMessageState('');
  };

  useEffect(() => {
    return () => clearExistingTimeout();
  }, []);

  return [message, showMessage, hideMessage];
}
